import { styled } from "@linaria/react"


import { Centered } from "@/components/Centered/Centered.ts"
import { SecondaryTextSpan } from "@/components/SecondaryTextSpan/SecondaryTextSpan.ts"
import * as textStyles from "@/styles/textStyles.ts"

import type { ReactNode } from "react"

export const Empty = (props: {
  illustration: ReactNode
  text: string
}) => {
  return (
    <Centered>
      <Container>
        {props.illustration}

        <EmptyText>
          {props.text}
        </EmptyText>
      </Container>
    </Centered>
  )
}

const Container = styled.div`
  flex: 0;

  position: relative;
`

const EmptyText = styled(SecondaryTextSpan)`
  ${textStyles.smallFontSize}

  position: absolute;
  right: 30px;
  bottom: 30px;
  left: 30px;

  z-index: 1;

  text-align: center;

  color: oklch(69.3% 0.054 284.904deg);
`
